import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface UserOrganisationUniqueData {
  isUnique: boolean
}

export function useUserOrganisationUnqiue(organisation: string) {
  const queryClient = useQueryClient();
  const { keycloak } = useKeycloak();

  return useQuery({
    enabled: !!organisation,
    queryKey: ['userOrganisationUnique', organisation],
    queryFn: async (): Promise<UserOrganisationUniqueData> => {
      const response = await fetch(
        `${import.meta.env.VITE_USER_ENGINE_ENDPOINT}/api/v1/bundles/user_bundle/functions/get_user_organisation_unique?organisation=${organisation}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'GET',
        }
      );

      let data = await response.json();

      const { is_unique } = data?.data;

      return {
        isUnique: is_unique ? is_unique : false
      };
    }
  });
}